import { OrientationType } from "@package/ui-gql/index-data-access";
import { MediaDisplay } from "@package/ui-wall-components";
import { useTriviaContext } from "../context-trivia";

type TriviaQuestionMediaProps = {
  media?: string;
  mediaAlt?: string;
  caption?: string;
};

export function TriviaQuestionMedia({
  media,
  mediaAlt,
  caption,
}: TriviaQuestionMediaProps) {
  const { containerSize } = useTriviaContext();

  if (!media) {
    return null;
  }

  const maxHeightClass =
    containerSize.orientation === OrientationType.Landscape
      ? "max-h-[30cqb]"
      : "max-h-[40cqb]";

  return (
    <div
      className={`flex w-full flex-col items-center gap-[var(--trivia-space)] ${maxHeightClass}`}
    >
      <MediaDisplay
        id={media}
        alt={mediaAlt ?? ""}
        classNameMedia={`max-w-full object-contain ${maxHeightClass}`}
      />
      {!!caption && (
        <div style={{ fontSize: "var(--trivia-text-meta)" }}>{caption}</div>
      )}
    </div>
  );
}
